import tw, { styled } from 'twin.macro';
import Link from '@/components/Link/Link';
import Icon from '@/components/Icon/IconAsset';

export const IconWrapper = styled.span`
  ${tw`flex`}
  ${tw`w-[16px]`}
  ${tw`h-[16px]`}
`;

export const StyledList = styled.ul`
  ${tw`p-1`}
`;

export const Wrapper = styled.section`
  ${tw`hidden shortHeight:hidden lg:block`};
  ${tw`z-[11]`}
  ${tw`fixed`};
  ${tw`top-[max(230px, 40%)]`};
  ${tw`right-0`};
  ${tw`bg-neutrals-n1/90`}
  ${tw`backdrop-blur-sm`}
  ${tw`rounded-tl-lg rounded-bl-lg`};
  ${tw`border-l-2 border-b-2 border-t-2 border-ui-colours-ui3`};
  ${tw`translate-x-[calc(100% - 60px)]`};
  ${tw`transition-transform`};
  ${tw`hover:translate-x-0`};
`;

export const StyledIcon = styled(Icon)`
  ${tw`inline`}
  ${tw`w-[16px]`}
  ${tw`max-h-[16px]`}
`;

export const StyledLink = styled(Link)<{ isActive: boolean }>`
  ${tw`flex`}
  ${tw`items-center`}
  ${tw`rounded-[4px]`}
  ${tw`gap-[21px]`}
  ${tw`py-[12px] px-2`}
  justify-content: start;
  ${tw`flex-row-reverse`}
  ${tw`whitespace-nowrap`}
  ${tw`text-body-s`}
  ${tw`font-medium`}
  ${tw`font-inter`}
  ${tw`text-neutrals-n7`}
  ${tw`hover:text-primary-p1`}
  ${tw`hover:bg-ui-colours-ui1`}
  ${({ isActive }) => isActive && [tw`text-primary-p1`]}

  ${StyledIcon} * {
    ${tw`fill-neutrals-n7`}
    ${({ isActive }) => isActive && tw`fill-primary-p1`}
  }

  &:hover ${StyledIcon} * {
    ${tw`fill-primary-p1`}
  }
`;
